function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "rotate/24x24-copy"
}, React.createElement("path", {
  d: "M3,2 C2.48716416,2 2.06449284,2.38604019 2.00672773,2.88337887 L2,3 L2,9 C2,9.51283584 2.38604019,9.93550716 2.88337887,9.99327227 L3,10 L9,10 C9.55228475,10 10,9.55228475 10,9 C10,8.48716416 9.61395981,8.06449284 9.11662113,8.00672773 L9,8 L5.07011747,8.00024218 C6.45332068,5.60890314 9.03877061,4 12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 C9.0393493,20 6.45433121,18.3917256 5.07092854,16.0011597 C4.97374799,15.8449094 4.89565287,15.6932111 4.8269043,15.5511169 L4.61909502,15.1150861 C4.5479984,14.9612991 4.47575301,14.7979749 4.40439318,14.621832 C4.19702037,14.109958 3.61395565,13.863111 3.10208168,14.0704839 C2.59020771,14.2778567 2.34336074,14.8609214 2.55073354,15.3727953 C2.70918542,15.7639141 2.86500708,16.118004 3.01863212,16.4355266 C3.1357648,16.6776244 3.27339981,16.923195 3.43134463,17.1725904 L3.59605225,17.4232736 C5.37829294,20.1774857 8.47631097,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C8.72781044,2 5.82269675,3.57163863 3.99834108,6.00123374 L4,3 C4,2.48716416 3.61395981,2.06449284 3.11662113,2.00672773 L3,2 Z",
  id: "rotate_left/24x24"
})));

var SvgIRotateLeft = function SvgIRotateLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIRotateLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-rotate-left.d6c2d878.svg";
export { ForwardRef as ReactComponent };